import { useContext } from "react";
import { ReplicateActionContext } from "./ReplicateActionContext";

function usePrepareReplicate() {
  const { setElementId, setShowModal } = useContext(ReplicateActionContext);
  return (id: any) => {
    setElementId(id);
    setShowModal(true);
  };
}

export default usePrepareReplicate;
